enum StatusCode {
    OK = "200",
    Created = "201",
    NoContent = "204",

    BadRequest = "400",
    Unauthorized = "401",
    Forbidden = "403",
    NotFound = "404",

    InternalServerError = "500",
    NotImplemented = "501"
}

namespace StatusCode {

    export function IsSuccess(code: StatusCode): boolean {
        return (
            code === StatusCode.OK ||
            code === StatusCode.Created ||
            code === StatusCode.NoContent);
    }

    export function IsFailure(code: StatusCode): boolean {
        return !StatusCode.IsSuccess(code);
    }

}

export {
    StatusCode
};
